<script setup lang="ts">
import { onClickOutside } from "@vueuse/core";
import { ref } from "vue";
import { logout } from "../auth/api";
import { getLegacyApp } from "../core/legacy-bridge";
import { t } from "../i18n";
import { appStore } from "../stores/app";

const header = appStore.header;

// User dropdown: opens on the user button, closes on any click outside it
const userButton = ref<HTMLElement>();
const isUserMenuOpen = ref(false);
onClickOutside(userButton, () => { isUserMenuOpen.value = false; });

async function onLogout() {
    await logout();
    window.location.reload();
}
</script>

<template>
    <div class="bulma-contextual">

        <nav class="navbar app__header">

            <a class="brand-logo navbar-brand p-5" :href="header.logoLink ? '/' : undefined">
                <figure class="image">
                    <img src="images/logo/eilersen-logo-2x.png" alt="Eilersen" />
                </figure>
            </a>

            <div class="navbar-menu is-active p-0">
                <div class="navbar-start">
                    <div class="navbar-item p-5">
                        <button class="back-button button is-black-hover is-bordered is-rounded" :class="{ show: header.backButton }" @click="getLegacyApp().onBackClicked()">
                            <span class="icon">
                                <i class="fas fa-chevron-left"></i>
                            </span>
                        </button>
                    </div>
                </div>

                <div class="navbar-end ml-auto">
                    <div class="navbar-item p-5">

                        <div class="columns is-mobile">
                            <div class="column is-flex is-align-items-center">
                                <div class="summary-menu" :class="{ 'is-active': header.summaryMenu }">
                                    <div class="summary-menu__series">
                                        <span class="summary-menu__series__name" v-html="header.seriesName"></span>
                                    </div>
                                    <div v-if="!header.isB2C" class="summary-menu__price">
                                        <span class="summary-menu__price__currency">{{ header.priceCurrency }}</span>
                                        <span class="summary-menu__price__value">{{ header.priceValue }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-flex is-align-items-center">
                                <div class="user-menu is-flex">
                                    <div class="columns is-mobile">
                                        <div class="column">
                                            <button class="summary-menu__button button is-default is-black-hover is-bordered is-radiusless" :class="{ show: header.summaryButton }" :disabled="header.summaryButtonDisabled" @click="getLegacyApp().onSummaryClicked()">
                                                <span v-html="t('common.summary')"></span>
                                                <span class="icon">
                                                    <i class="fas fa-long-arrow-alt-right"></i>
                                                </span>
                                            </button>
                                        </div>
                                        <div class="column">
                                            <div v-if="!header.isB2C" class="user-menu__wrapper" :class="{ show: header.userMenu }">
                                                <span class="user-menu__label" v-html="header.userName"></span>
                                                <div class="dropdown is-right" :class="{ 'is-active': isUserMenuOpen }">
                                                    <div class="dropdown-trigger">
                                                        <button ref="userButton" class="user-menu__button button is-black-hover is-bordered is-rounded" :class="{ 'is-black': isUserMenuOpen }" aria-haspopup="true" aria-controls="dropdown-menu" @click.prevent.stop="isUserMenuOpen = true">
                                                            <span class="icon">
                                                                <i class="fas fa-user"></i>
                                                            </span>
                                                        </button>
                                                    </div>
                                                    <div class="dropdown-menu">
                                                        <div class="dropdown-content">
                                                            <a href="#" id="projects" class="dropdown-item" @click="getLegacyApp().onProjectsClicked()">
                                                                <span class="icon is-small"><i class="fas fa-list"></i></span>
                                                                <span>Configurations</span>
                                                            </a>
                                                            <a href="#" id="logout" class="dropdown-item" @click="onLogout">
                                                                <span class="icon is-small"><i class="fas fa-unlock"></i></span>
                                                                <span>Logout</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>
